import { Grid } from '@mui/material';
import { PDFFooter } from '../../molecules/PDFFooter/PDFFooter';
import { PDFHeader } from '../../molecules/PDFHeader/PDFHeader';
import { PDFTitle } from '../../organisms/PDF/PDFTitle';
import { GoalTypeEnum } from 'common/types';
import { useTranslation } from 'react-i18next';
import { AllocationsOverTimeTab } from '../../../containers/review-plan-details/AllocationsOverTimeTab';
import { MarketPortfolioTenure } from '../../organisms/PortfolioComposition/useMarketPortfolioData';

export interface PDFAllocationsOverTimeChartProps {
    goalType: string;
    goalName: string;
    priority: 'Need' | 'Want' | 'Wish' | 'Dream' | 'onTrack' | 'offTrack' | 'atRisk';
    type: GoalTypeEnum;
    retirementYear?: number;
    portfolioPath: Array<number>;
    tenure?: MarketPortfolioTenure;
    totalPages: number;
    currentPage: number;
}

export const PDFAllocationsOverTimeChart = ({
    goalType,
    goalName,
    priority,
    type,
    retirementYear,
    portfolioPath,
    tenure,
    totalPages,
    currentPage
}: PDFAllocationsOverTimeChartProps) => {
    const { t } = useTranslation();

    return (
        <Grid height={'1000px'} position={'relative'} marginBottom={'40px'}>
            <PDFHeader pageName={t('ALLOCATIONS_OVER_TIME')} />
            <PDFTitle goalType={goalType} goalName={goalName} type={type} priority={priority} />
            <AllocationsOverTimeTab
                retirementYear={retirementYear}
                portfolioPath={portfolioPath}
                tenure={tenure}
                isPDF
            />
            <PDFFooter currentPage={currentPage} totalPages={totalPages} />
        </Grid>
    );
};
